import { render, staticRenderFns } from "./baseTradeFooter.vue?vue&type=template&id=1d544fec&scoped=true"
import script from "./baseTradeFooter.vue?vue&type=script&lang=js"
export * from "./baseTradeFooter.vue?vue&type=script&lang=js"
import style0 from "./baseTradeFooter.vue?vue&type=style&index=0&id=1d544fec&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d544fec",
  null
  
)

export default component.exports